import types from './constant';

export const onOpen                   = data  => ({type: types.MODAL_OPENED, payload: data });
export const onClose                  = data  => ({type: types.MODAL_CLOSED, payload: data });
export const setModal                 = data  => ({type: types.MODAL_SET_MANAGER, payload: data });
export const setPropsModalByNameProps = data  => ({type: types.MODAL_SET_BY_NAME_PROPS, payload: data });
export const setModalProps            = data  => ({type: types.MODAL_SET_PROPS, payload: data})